export const HEADER_HEIGHT = 60;
export const NAVIGATION_HEIGHT = 40;
export const FOOTER_HEIGHT = 40;
export const SIDEMENU_WIDTH = 190;

export const COGNITO_CONFIG = {
	region: import.meta.env.VITE_AWS_REGION || "",
	userPoolId: import.meta.env.VITE_COGNITO_USERPOOL_ID || "",
	userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || "",
};

export const COGNITO_IDPOOL_ID = import.meta.env.VITE_COGNITO_IDPOOL_ID || "";

// アイコン画像用ファイルパス
export const TERM_ICON_PATH = "/cope-icon.png";

//TODO: ファイルパスを変える
export const ATHLETE_CONDITION_CHECK_JSON_PATH = "acca/information/information.json";

/**
 * 管理者ロール定数
 */
export const ADMIN_ROLES = ["管理者", "実行者"] as const;

export type AdminRole = (typeof ADMIN_ROLES)[number];

/**
 * SWRキーを管理
 */
export const SWR_KEYS = {
	termVersionHistory: (type: string) => `terms/${type}/versions`,
} as const;

export { getTermsJsonKey, TERM_PATHS } from "./terms";
